export const CONVO_DETAIL_REPORT_PATH = '/reports/conversations/data'
